/* bar-configurator.js */
(function () {
  'use strict';

  const root = document.getElementById('bar-configurator');
  if (!root) return;

  /* ── Config depuis data-attributes ── */
  const PACKS = {
    10: { qty: parseInt(root.dataset.pack10Qty) || 10,  discount: parseInt(root.dataset.pack10Discount) || 10 },
    20: { qty: parseInt(root.dataset.pack20Qty) || 20,  discount: parseInt(root.dataset.pack20Discount) || 15 },
    50: { qty: parseInt(root.dataset.pack50Qty) || 50,  discount: parseInt(root.dataset.pack50Discount) || 20 },
  };
  const TXT = {
    max:         root.dataset.txtMax         || 'Maximum atteint',
    added:       root.dataset.txtAdded       || '✓ Pack ajouté au panier !',
    unavailable: root.dataset.txtUnavailable || 'Un produit est indisponible.',
  };

  /* ── State ── */
  let activePack = null;  // 10 | 20 | 50
  let quota = 0;
  let discount = 0;

  /* ── Helpers DOM ── */
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ── Steps ── */
  const stepChoice = $('#bar-step-choice');
  const stepConfig = $('#bar-step-config');

  function showStep(step) {
    [stepChoice, stepConfig].forEach(s => s.hidden = true);
    step.hidden = false;
  }

  /* ── Pack selection ── */
  $$('.bar-pack__card').forEach(card => {
    const trigger = (e) => {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      selectPack(parseInt(card.dataset.pack));
    };
    card.addEventListener('click', trigger);
    card.addEventListener('keydown', trigger);
    const btn = card.querySelector('.bar-pack__btn');
    if (btn) btn.addEventListener('click', e => { e.stopPropagation(); selectPack(parseInt(card.dataset.pack)); });
  });

  function selectPack(packKey) {
    activePack = packKey;
    quota = PACKS[packKey].qty;
    discount = PACKS[packKey].discount;

    /* Reset all cards */
    $$('.bc-card').forEach(c => {
      setCardQty(c, 0);
    });

    /* Badge header */
    $('#bc-pack-badge').textContent = `Pack ${quota} barres · −${discount}%`;

    /* Quotas */
    $('#bc-quota').textContent = quota;
    $('#bc-pill-quota').textContent = quota;
    $('#bc-sticky-quota').textContent = quota;

    updateProgress();
    showStep(stepConfig);
    updateSticky();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ── Back button ── */
  $('#bc-back').addEventListener('click', () => {
    showStep(stepChoice);
    $('#bar-sticky').classList.remove('bar-sticky--visible');
  });

  /* ── Card controls ── */
  $('#bar-grid').addEventListener('click', e => {
    const btn = e.target.closest('.bc-card__btn');
    if (!btn) return;
    const card = btn.closest('.bc-card');
    if (card.dataset.soldOut === 'true') return;

    const current = getCardQty(card);
    if (btn.classList.contains('bc-card__btn--plus')) {
      if (totalSelected() >= quota) { showToast(TXT.max); return; }
      setCardQty(card, current + 1);
    } else {
      if (current <= 0) return;
      setCardQty(card, current - 1);
    }
    updateProgress();
    updateSticky();
  });

  function getCardQty(card) {
    return parseInt(card.querySelector('.bc-card__qty').textContent) || 0;
  }

  function setCardQty(card, qty) {
    card.querySelector('.bc-card__qty').textContent = qty;
    card.querySelector('.bc-card__badge-qty').textContent = qty;
    card.querySelector('.bc-card__btn--minus').disabled = qty <= 0;
    card.classList.toggle('bc-card--selected', qty > 0);
  }

  function totalSelected() {
    return $$('.bc-card').reduce((sum, c) => sum + getCardQty(c), 0);
  }

  /* ── Progress ── */
  function updateProgress() {
    const total = totalSelected();
    const pct = quota > 0 ? Math.min((total / quota) * 100, 100) : 0;
    $('#bc-count').textContent = total;
    $('#bc-fill').style.width = pct + '%';
    $('#bc-pill-count').textContent = total;
  }

  /* ── Sticky bar ── */
  function updateSticky() {
    const total = totalSelected();
    const done = total >= quota;
    const pct = quota > 0 ? Math.min((total / quota) * 100, 100) : 0;

    $('#bc-sticky-fill').style.width = pct + '%';
    $('#bc-sticky-count').textContent = total;

    const hint = document.getElementById('bc-sticky-hint');
    if (done) {
      hint.textContent = '— Sélection complète ✓';
      hint.style.color = 'var(--bc-brand)';
    } else {
      const remaining = quota - total;
      hint.textContent = `— encore ${remaining} barre${remaining > 1 ? 's' : ''}`;
      hint.style.color = '';
    }

    /* Prix */
    const baseTotal = $$('.bc-card').reduce((sum, c) => {
      const qty = getCardQty(c);
      const price = parseInt(c.dataset.price) || 0;
      return sum + qty * price;
    }, 0);

    const discounted = baseTotal * (1 - discount / 100);
    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' €';

    const priceEl = document.getElementById('bc-sticky-amount');
    if (total > 0) {
      priceEl.textContent = fmt(discounted);
      const discBadge = document.getElementById('bc-sticky-discount');
      discBadge.textContent = `−${discount}%`;
    } else {
      priceEl.textContent = '—';
      document.getElementById('bc-sticky-discount').textContent = '';
    }

    const cta = $('#bc-add-to-cart');
    cta.disabled = !done;

    $('#bar-sticky').classList.toggle('bar-sticky--visible', total > 0 || activePack !== null);
  }

  /* ── Add to cart ── */
  $('#bc-add-to-cart').addEventListener('click', async () => {
    const cards = $$('.bc-card').filter(c => getCardQty(c) > 0);
    if (!cards.length) return;

    /* Vérif disponibilité */
    const hasUnavailable = cards.some(c => c.dataset.soldOut === 'true');
    if (hasUnavailable) { showToast(TXT.unavailable); return; }

    const cta = $('#bc-add-to-cart');
    cta.classList.add('bar-sticky__cta--loading');
    cta.disabled = true;

    /* Barres sélectionnées */
    const items = cards.map(c => ({
      id: parseInt(c.dataset.variantId),
      quantity: getCardQty(c),
      properties: { '_pack': `Pack ${quota} barres (−${discount}%)` }
    }));

    /* ── Ligne de remise ──
       Shopify ne permet pas les prix négatifs côté client.
       On ajoute un produit "Remise Pack" dont le prix unitaire
       correspond exactement à la remise calculée (centimes négatifs
       stockés dans data-discount-variant-XX sur le root).
       Vous devez créer 3 produits "Remise" dans l'admin Shopify :
         - Un produit par palier (10 / 20 / 50) avec un prix = 0,01 €
         - Cochez "Ne pas suivre l'inventaire"
         - Masquez-les (statut Archivé ou Brouillon)
       Puis renseignez leurs variant IDs dans les settings de la section.
    ── */
    const discountVariantId = root.dataset[`discountVariant${activePack}`];
    if (discountVariantId) {
      /* Calcul du montant de remise en centimes */
      const baseTotal = cards.reduce((sum, c) => {
        return sum + getCardQty(c) * (parseInt(c.dataset.price) || 0);
      }, 0);
      const discountAmount = Math.round(baseTotal * discount / 100);

      items.push({
        id: parseInt(discountVariantId),
        quantity: 1,
        properties: {
          '_type': 'remise',
          '_label': `Remise Pack ${quota} barres −${discount}%`,
          /* On stocke le montant pour affichage — le prix réel
             doit être géré via Shopify Functions ou un script côté serveur.
             Sans Functions, ce produit sert de ligne visuelle indicative. */
          '_montant': `−${(discountAmount / 100).toFixed(2).replace('.', ',')} €`
        }
      });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error();

      /* Dispatch event pour les thèmes qui écoutent */
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      showToast(TXT.added);

      /* Reset */
      setTimeout(() => {
        $$('.bc-card').forEach(c => setCardQty(c, 0));
        updateProgress();
        updateSticky();
        showStep(stepChoice);
        $('#bar-sticky').classList.remove('bar-sticky--visible');
        activePack = null;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 1800);

    } catch {
      showToast('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      cta.classList.remove('bar-sticky__cta--loading');
      cta.disabled = false;
    }
  });

  /* ── Toast ── */
  let toastTimer;
  function showToast(msg) {
    const toast = $('#bar-toast');
    toast.textContent = msg;
    toast.classList.add('bar-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('bar-toast--visible'), 2800);
  }

  /* ── Sticky visibility en scroll ── */
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && activePack === null) {
      $('#bar-sticky').classList.remove('bar-sticky--visible');
    }
  }, { threshold: 0.1 });
  observer.observe(stepChoice);

})();